import "./TrustedBy.css";

const BRANDS = [
  { name: "NHS", style: "font-bold tracking-tight", color: "#005EB8" },
  { name: "Deloitte", style: "font-bold tracking-tight", color: "#86BC25" },
  { name: "EY", style: "font-extrabold tracking-tight italic", color: "#FFE600", bg: "#2E2E38" },
  { name: "PwC", style: "font-extrabold tracking-tight", color: "#D04A02" },
  { name: "Barclays", style: "font-semibold tracking-tight", color: "#00AEEF" },
  { name: "HSBC", style: "font-bold tracking-[0.18em]", color: "#DB0011" },
  { name: "Amazon", style: "font-semibold tracking-tight", color: "#FF9900" },
  { name: "Microsoft", style: "font-semibold tracking-tight", color: "#737373" },
];

const Pill = ({ b }) => {
  const padded = b.bg;
  return (
    <span
      data-testid={`trusted-brand-${b.name.toLowerCase()}`}
      className={`font-serif text-2xl md:text-3xl whitespace-nowrap select-none ${b.style} ${
        padded ? "px-3 py-1 rounded-md" : ""
      }`}
      style={{ color: b.color, backgroundColor: padded || "transparent" }}
    >
      {b.name}
    </span>
  );
};

export default function TrustedBy() {
  // duplicate for seamless loop
  const list = [...BRANDS, ...BRANDS];
  return (
    <section
      data-testid="trusted-by-strip"
      className="bg-foreground text-background py-8 md:py-10 border-y border-background/10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 items-center gap-6">
          <div className="md:col-span-3 lg:col-span-3">
            <p className="text-[10px] uppercase tracking-[0.28em] text-background/50 font-bold">
              Trusted by professionals from
            </p>
            <p className="font-serif text-lg md:text-xl mt-1 leading-tight text-background/90">
              World-class organisations
            </p>
          </div>
          <div className="md:col-span-9 lg:col-span-9 marquee">
            <div className="marquee__track">
              {list.map((b, i) => (
                <span key={i} className="inline-flex items-center">
                  <Pill b={b} />
                  <span className="ml-16 text-background/15 select-none">•</span>
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
